import { Component, OnInit } from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";

@Component({
  selector: 'app-form-group-test',
  templateUrl: './form-group-test.component.html',
  styleUrls: ['./form-group-test.component.css']
})
export class FormGroupTestComponent implements OnInit {


  processForm: FormGroup;
  form: FormGroup;

  ngOnInit() {
    this.form = this.formBuilder.group({
      'Xs': this.formBuilder.array([
        this.initX()
      ])
    });

    this.processForm = new FormGroup({
      key: new FormControl('', []),
      name: new FormControl('', [Validators.required]),
      description: new FormControl('', [Validators.required]),
      processType: new FormControl('', [Validators.required]),
      model: new FormControl('', []),
      propertySets: this.formBuilder.array([
          this.initPropertySet()]
      ),
      publicOutputInd: new FormControl('', []),
      outputName: new FormControl('', []),
      level: new FormControl('0', []),
    });
    // this.processForm = new FormGroup({
    //   key: new FormControl('', []),
    //   name: new FormControl('', [Validators.required]),
    //   description: new FormControl('', [Validators.required]),
    //   processType: new FormControl('', [Validators.required]),
    //   model: new FormControl('', []),
    //   propertySets: this.formBuilder.array([
    //       this.initProcessPropertySet()]
    //   ),
    //   publicOutputInd: new FormControl('', []),
    //   outputName: new FormControl('', []),
    //   level: new FormControl('0', []),
    // });

  }

  initX() {
    return this.formBuilder.group({
      //  ---------------------forms fields on x level ------------------------
      'X': ['X', [Validators.required, Validators.pattern('[0-9]{3}')]],
      // ---------------------------------------------------------------------
      'Ys': this.formBuilder.array([
        this.initY()
      ])
    });
  }

  initPropertySet() {
    return this.formBuilder.group({
      //  ---------------------forms fields on x level ------------------------
      'name': ['', []],
      // ---------------------------------------------------------------------
      'properties': this.formBuilder.array([
        this.initProperties()
      ])
    });
  }

  initProperties() {
    return this.formBuilder.group({
      //  ---------------------forms fields on x level ------------------------
      'name': ['', []],
      'value': ['', []],
    });
  }

  initY() {
    return this.formBuilder.group({
      //  ---------------------forms fields on y level ------------------------
      'Y1': ['Y1', [Validators.required, Validators.pattern('[0-9]{3}')]],
      'Y2': ['Y2', [Validators.required, Validators.pattern('[0-9]{3}')]],
      // ---------------------------------------------------------------------
      'Zs': this.formBuilder.array([
        this.initZ()
      ])
    })
  }

  initZ() {
    return this.formBuilder.group({
      //  ---------------------forms fields on z level ------------------------
      'Z': ['Z', [Validators.required, Validators.pattern('[0-9]{3}')]],
      // ---------------------------------------------------------------------
    })
  }

  addX() {
    const control = <FormArray>this.form.controls['Xs'];
    control.push(this.initX());
  }


  addY(ix) {
    const control = (<FormArray>this.form.controls['Xs']).at(ix).get('Ys') as FormArray;
    control.push(this.initY());
  }


  addPropertySet() {
    const control = <FormArray>this.processForm.controls['propertySets'];
    control.push(this.initPropertySet());
  }

  deletePropertySet(propertySetsIndex: number) {
    const control = <FormArray>this.processForm.controls['propertySets'];
    control.removeAt(propertySetsIndex);
  }

  addProcessProperty(propertySetsIndex: number) {
    const control = (<FormArray>this.processForm.controls['propertySets']).at(propertySetsIndex).get('properties') as FormArray;
    control.push(this.initProperties());
  }

  deleteProcessProperty(propertySetsIndex: number, propertyIndex: number) {
    const control = (<FormArray>this.processForm.controls['propertySets']).at(propertySetsIndex).get('properties') as FormArray;
    control.removeAt(propertyIndex);
  }

  constructor(private formBuilder: FormBuilder) {}

}

